import axiosInstance from './axiosInstance';

const getApiUrl = () => process.env.REACT_APP_API_URL || axiosInstance.defaults.baseURL || '';

export const getCostItems = async () => {
  try {
    const response = await axiosInstance.get(`${getApiUrl()}/cost-items`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cost items:', error.response?.data || error);
    throw error;
  }
};

export const getCostItemById = async (id) => {
  try {
    const response = await axiosInstance.get(`${getApiUrl()}/cost-items/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cost item:', error.response?.data || error);
    throw error;
  }
};

export const getCostItemsByWorkOrderId = async (workOrderId) => {
  const response = await axiosInstance.get(`${getApiUrl()}/cost-items`, {
    params: { workOrderId },
  });
  return response.data;
};

export const createCostItem = async (payload) => {
  try {
    const response = await axiosInstance.post(`${getApiUrl()}/cost-items`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating cost item:', error.response?.data || error);
    throw error;
  }
};

export const updateCostItem = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`${getApiUrl()}/cost-items/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating cost item:', error.response?.data || error);
    throw error;
  }
};

export const deleteCostItem = async (id) => {
  try {
    const response = await axiosInstance.delete(`${getApiUrl()}/cost-items/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting cost item:', error.response?.data || error);
    throw error;
  }
};
